import React from 'react';
import PropTypes from 'prop-types';

import {
    CarouselGrid,
    TextSliderWrapper,
    TitleWrapper,
    Title,
    ImageSliderProvider
} from '~/components/blocks/acf/FeaturesCarousel';
import TextSlider from '~/components/features-carousel/TextSlider';
import ImageSlider from '~/components/features-carousel/ImageSlider';

import { formatText } from '~/utilities/helpers';

const FeaturesCarousel = ({ title, slides, state, dispatch }) => {
    return (
        <CarouselGrid singleSlide={slides.length < 2}>
            <TextSliderWrapper>
                <TitleWrapper>
                    <Title noButtons={slides.length < 2}>
                        {formatText(title)}
                    </Title>
                </TitleWrapper>
                <TextSlider
                    {...{ slides }}
                    featuresCarouselState={state}
                    featuresCarouselDispatch={dispatch}
                />
            </TextSliderWrapper>
            <ImageSliderProvider
                totalSlides={slides.length}
                naturalSlideHeight={800}
                naturalSlideWidth={500}
                visibleSlides={1}
                orientation="vertical"
            >
                <ImageSlider
                    {...{ slides }}
                    usePhoneScreen={false}
                    featuresCarouselState={state}
                    featuresCarouselDispatch={dispatch}
                />
            </ImageSliderProvider>
        </CarouselGrid>
    );
};

FeaturesCarousel.propTypes = {
    title: PropTypes.string.isRequired,
    slides: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string,
            image: PropTypes.shape({
                id: PropTypes.string.isRequired,
                altText: PropTypes.string,
                sourceUrl: PropTypes.string.isRequired,
                localFile: PropTypes.shape({
                    childImageSharp: PropTypes.shape({
                        gatsbyImageData: PropTypes.object.isRequired
                    })
                })
            })
        })
    ),
    state: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired
};

export default FeaturesCarousel;
